<template>
  <div class="parent-child-reward-main-container pb-sm-0">
    <p class="small text-muted align-items-center">
      <span>
        {{ userIsAParent ? currentChild.text : getUserName }} has earned {{ starsEarned }} out of
        {{ totalStarsToday }}
        <b-img :src="require('@/assets/star.png')" class="icon-star-small"></b-img>
        today
      </span>
    </p>
    <div class="child-reward-daily-rewards pl-2 d-flex flex-column w-100">
      <div class="d-flex align-items-center">
        <span class="child-reward-title mr-2">Daily Rewards</span>
        <question-popup
          popover-key="daily-rewards"
          variant="primary"
          :title="dailyPopup['title']"
          :description="dailyPopup['information']"
        />
      </div>
      <div
        :class="
          userIsAParent
            ? 'border d-flex rounded p-4 p-sm-3 mb-2 m-0 justify-content-between row flex-nowrap flex-md-wrap overflow-auto justify-content-sm-start row-gap-one'
            : 'custom-grid'
        "
      >
        <empty-module
          v-if="!todayRewardsList || (todayRewardsList && todayRewardsList.length) == 0"
          title="No daily rewards have been added yet"
          :icon="'card_giftcard'"
          :customClass="'w-100'"
        />
        <template v-else>
          <reward-card
            v-for="(reward, index) in todayRewardsList"
            :key="'dailyReward-' + index"
            :claimReward="claimReward"
            :customClass="userIsAParent ? 'col-12 col-sm-6 col-md-6 col-lg-4 px-2' : 'reward-card'"
            :rewardData="reward"
            :editReward="editReward"
            :deleteReward="deleteReward"
            :canClaim="!isOnParent"
            :isDaily="true"
            :starsBanked="availableStars"
            :sectionColor="'#F09096'"
            @duplicate-select-change="updateRewardsToDuplicate($event, reward.id)"
          >
          </reward-card>
        </template>
      </div>
    </div>
    <div class="child-reward-big-rewards d-flex flex-column w-100">
      <span class="child-reward-title">Big Rewards</span>
      <div :class="userIsAParent ? 'border d-flex row flex-nowrap flex-md-wrap overflow-auto rounded p-4 p-sm-3 row m-0 row-gap-one' : 'custom-grid'">
        <empty-module
          v-if="!otherRewardsList || (otherRewardsList && otherRewardsList.length) == 0"
          title="No big rewards have been added yet"
          :icon="'card_giftcard'"
          :customClass="'w-100'"
        />
        <template v-else>
          <reward-card
            v-for="(reward, index) in otherRewardsList"
            :key="'bigReward-' + index"
            :claimReward="claimReward"
            :customClass="userIsAParent ? 'col-12 col-sm-6 col-md-6 col-lg-4 px-2' : 'reward-card'"
            :rewardData="reward"
            :editReward="editReward"
            :deleteReward="deleteReward"
            :canClaim="!isOnParent"
            :isDaily="false"
            :starsBanked="availableStars"
            @duplicate-select-change="updateRewardsToDuplicate($event, reward.id)"
          ></reward-card>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import emptyModule from '@/components/general/emptyModule.vue';
import QuestionPopup from '@/components/general/QuestionPopup.vue';
import RewardCard from './rewardCard.vue';

export default {
  name: 'parent-children-rewards',
  props: {
    todayRewardsList: {
      type: Array,
      defaul: [],
    },
    otherRewardsList: {
      type: Array,
      defaul: [],
    },
    availableStars: {
      type: Number,
      defaul: 0,
    },
    editReward: {
      type: Function,
      value: () => {},
    },
    deleteReward: {
      type: Function,
      value: () => {},
    },
    claimReward: {
      type: Function,
      default: () => {
        return;
      },
    },
    currentChild: {
      type: Object,
      default: null,
    },
    totalStarsToday: {
      type: Number,
      default: 0,
    },
    starsEarned: {
      type: Number,
      default: 0,
    },
    dailyPopup: {
      type: Object,
      default: () => ({ title: '', information: '' }),
    },
  },
  components: { RewardCard, emptyModule, QuestionPopup },
  data() {
    return {
      isOnParent: false,
      rewardsToDuplicate: [],
    };
  },
  computed: {
    ...mapState('rewards', ['isDuplicateActivate']),
    ...mapGetters('user', ['userIsAParent', 'getParentName', 'getUserName']),
    ...mapGetters('rewards', ['getChildSelectedRewards']),
    ...mapGetters('user', ['getUserId']),
    starsBanked() {
      const selectedRewards = this.getChildSelectedRewards(this.getUserId);
      return selectedRewards ? selectedRewards.available_stars : 0;
    },
  },
  methods: {
    updateRewardsToDuplicate(isSelected, rewardId) {
      const currentList = [...this.rewardsToDuplicate];

      if (isSelected) currentList.push(rewardId);
      else currentList.splice(currentList.indexOf(rewardId), 1);

      this.rewardsToDuplicate = currentList;
      this.$emit('update:rewardsToDuplicate', currentList);
    },
  },
  watch: {
    isDuplicateActivate(value) {
      if (!value) {
        this.rewardsToDuplicate = [];
        this.$emit('update:rewardsToDuplicate', []);
      }
    },
  },
  mounted() {
    this.isOnParent = this.userIsAParent;
  },
};
</script>

<style lang="scss" scoped>
.parent-child-reward-main-container {
  display: flex;
  flex-direction: column;
  width: 95%;
  margin: auto;
  gap: 1rem;

  .row-gap-one {
    row-gap: 1rem;
  }

  .custom-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 1rem;
    gap: 1rem;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    @media (max-width: 500px) {
      border: none;
    }
  }

  .reward-card {
    flex-basis: 30%;
    height: 130px;
    margin-top: 20px;
    min-width: 300px;
    background-color: #ffffff;
  }

  .child-reward-daily-rewards {
    .wrapper-question-popover {
      color: #1e90ff;
    }
  }
}

</style>
